/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <>
      <nav className="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <Link className="w-20 text-sm inline-flex items-center mr-3 my-2" to="/">
              <img alt="logo" className="w-full border-none" src={require("assets/img/vending_logo_2.png").default} />
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
}
